"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiAuthOptions = exports.DAMetaOSCapabilityOptions = exports.ActionStartOptions = exports.DACapabilityOptions = exports.NotificationBotOptions = exports.BotCapabilityOptions = exports.OfficeAddinCapabilityOptions = exports.MeArchitectureOptions = exports.MeCapabilityOptions = exports.CustomCopilotAssistantOptions = exports.CustomCopilotRagOptions = exports.TeamsAgentCapabilityOptions = exports.TabCapabilityOptions = exports.CustomEngineAgentOptions = void 0;
exports.setTemplateName = setTemplateName;
exports.setTemplateNameAndGC = setTemplateNameAndGC;
const featureFlags_1 = require("../../../common/featureFlags");
const localizeUtils_1 = require("../../../common/localizeUtils");
const templateNames_1 = require("../../../component/generator/templates/templateNames");
const constants_1 = require("../../constants");
const questionNames_1 = require("../../questionNames");
class CustomEngineAgentOptions {
    static basicCustomEngineAgent() {
        return {
            id: "basic-custom-engine-agent",
            label: (0, localizeUtils_1.getLocalizedString)("template.customEngineAgent.basic.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("template.customEngineAgent.basic.detail"),
            data: templateNames_1.TemplateNames.BasicCustomEngineAgent,
        };
    }
    static weatherAgent() {
        return {
            id: "weather-agent",
            label: (0, localizeUtils_1.getLocalizedString)("template.customEngineAgent.weather.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("template.customEngineAgent.weather.detail"),
            data: templateNames_1.TemplateNames.WeatherAgent,
        };
    }
}
exports.CustomEngineAgentOptions = CustomEngineAgentOptions;
class TabCapabilityOptions {
    static nonSsoTab() {
        return {
            id: "tab-non-sso",
            label: `${(0, localizeUtils_1.getLocalizedString)("core.TabNonSso.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.TabNonSso.detail"),
            // description: getLocalizedString(
            //   "core.createProjectQuestion.option.description.worksInOutlookM365"
            // ),
            data: templateNames_1.TemplateNames.Tab,
        };
    }
    static m365SsoLaunchPage() {
        return {
            id: "sso-launch-page",
            label: `${(0, localizeUtils_1.getLocalizedString)("core.M365SsoLaunchPageOptionItem.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.M365SsoLaunchPageOptionItem.detail"),
            description: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.option.description.worksInOutlookM365"),
            data: templateNames_1.TemplateNames.SsoTabNaa,
        };
    }
    static dashboardTab() {
        return {
            id: "dashboard-tab",
            label: (0, localizeUtils_1.getLocalizedString)("core.DashboardOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.DashboardOption.detail"),
            description: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.option.description.worksInOutlookM365"),
            data: templateNames_1.TemplateNames.DashboardTab,
            buttons: [
                {
                    iconPath: "file-symlink-file",
                    tooltip: (0, localizeUtils_1.getLocalizedString)("core.option.github"),
                    command: "fx-extension.openTutorial",
                },
            ],
        };
    }
    // TODO: need further sub-options to decide template name
    static SPFxTab() {
        return {
            id: "tab-spfx",
            label: (0, localizeUtils_1.getLocalizedString)("core.TabSPFxOption.labelNew"),
            description: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.option.description.worksInOutlookM365"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.TabSPFxOption.detailNew"),
        };
    }
}
exports.TabCapabilityOptions = TabCapabilityOptions;
class TeamsAgentCapabilityOptions {
    static basicChatbot() {
        const description = featureFlags_1.featureFlagManager.getBooleanValue(featureFlags_1.FeatureFlags.CEAEnabled)
            ? (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customEngineAgent.description")
            : undefined;
        return {
            id: "custom-copilot-basic",
            label: (0, localizeUtils_1.getLocalizedString)("template.teams.general.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("template.teams.general.detail"),
            description: description,
            data: templateNames_1.TemplateNames.CustomCopilotBasic,
        };
    }
    static customCopilotRag() {
        const description = featureFlags_1.featureFlagManager.getBooleanValue(featureFlags_1.FeatureFlags.CEAEnabled)
            ? (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customEngineAgent.description")
            : undefined;
        return {
            id: "custom-copilot-rag",
            label: (0, localizeUtils_1.getLocalizedString)("template.teams.rag.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("template.teams.rag.detail"),
            description: description,
        };
    }
    static collaboratorAgent() {
        return {
            id: "teams-collaborator-agent",
            label: (0, localizeUtils_1.getLocalizedString)("template.teams.collaboratorAgent.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("template.teams.collaboratorAgent.detail"),
            data: templateNames_1.TemplateNames.TeamsCollaboratorAgent,
        };
    }
    static others() {
        const description = featureFlags_1.featureFlagManager.getBooleanValue(featureFlags_1.FeatureFlags.CEAEnabled)
            ? (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customEngineAgent.description")
            : undefined;
        return {
            id: "others",
            label: (0, localizeUtils_1.getLocalizedString)("template.teams.others.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("template.teams.others.detail"),
            description: description,
        };
    }
}
exports.TeamsAgentCapabilityOptions = TeamsAgentCapabilityOptions;
class CustomCopilotRagOptions {
    static customize() {
        return {
            id: "custom-copilot-rag-customize",
            label: (0, localizeUtils_1.getLocalizedString)("template.teams.rag.source.customize.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("template.teams.rag.source.customize.detail"),
            data: templateNames_1.TemplateNames.CustomCopilotRagCustomize,
        };
    }
    static azureAISearch() {
        return {
            id: "custom-copilot-rag-azureAISearch",
            label: (0, localizeUtils_1.getLocalizedString)("template.teams.rag.source.azureAISearch.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("template.teams.rag.source.azureAISearch.detail"),
            data: templateNames_1.TemplateNames.CustomCopilotRagAzureAISearch,
        };
    }
    static customApi() {
        return {
            id: "custom-copilot-rag-customApi",
            label: (0, localizeUtils_1.getLocalizedString)("template.teams.rag.source.customApi.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("template.teams.rag.source.customApi.detail"),
            description: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.option.description.preview"),
            data: templateNames_1.TemplateNames.CustomCopilotRagCustomApi,
        };
    }
    static microsoft365() {
        return {
            id: "custom-copilot-rag-microsoft365",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotRagMicrosoft365Option.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotRagMicrosoft365Option.detail"),
            data: templateNames_1.TemplateNames.CustomCopilotRagMicrosoft365,
        };
    }
}
exports.CustomCopilotRagOptions = CustomCopilotRagOptions;
class CustomCopilotAssistantOptions {
    static new() {
        return {
            id: "custom-copilot-agent-new",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotAssistantNewOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotAssistantNewOption.detail"),
            data: templateNames_1.TemplateNames.CustomCopilotAssistantNew,
        };
    }
    static assistantsApi() {
        return {
            id: "custom-copilot-agent-assistants-api",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotAssistantAssistantsApiOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotAssistantAssistantsApiOption.detail"),
            description: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.option.description.preview"),
            data: templateNames_1.TemplateNames.CustomCopilotAssistantAssistantsApi,
        };
    }
}
exports.CustomCopilotAssistantOptions = CustomCopilotAssistantOptions;
class MeCapabilityOptions {
    static basicMe() {
        return {
            id: "basic-message-extension",
            label: (0, localizeUtils_1.getLocalizedString)("core.MessageExtensionOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.MessageExtensionOption.detail"),
            data: templateNames_1.TemplateNames.DefaultMessageExtension,
        };
    }
    // need further sub-options to decide template name
    static m365SearchMe() {
        return {
            id: "search-app",
            label: `${(0, localizeUtils_1.getLocalizedString)("core.M365SearchAppOptionItem.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.M365SearchAppOptionItem.copilot.detail"),
        };
    }
    static collectFormMe() {
        return {
            id: "collect-form-message-extension",
            label: `${(0, localizeUtils_1.getLocalizedString)("core.MessageExtensionOption.labelNew")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.MessageExtensionOption.detail"),
            data: templateNames_1.TemplateNames.MessageExtensionAction,
        };
    }
    static linkUnfurling() {
        return {
            id: "link-unfurling",
            label: `${(0, localizeUtils_1.getLocalizedString)("core.LinkUnfurlingOption.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.LinkUnfurlingOption.detail"),
            description: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.option.description.worksInOutlook"),
            data: templateNames_1.TemplateNames.LinkUnfurling,
        };
    }
}
exports.MeCapabilityOptions = MeCapabilityOptions;
class MeArchitectureOptions {
    static botMe() {
        return {
            id: "bot",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.botMessageExtension.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.botMessageExtension.detail"),
            description: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.option.description.worksInOutlook"),
            data: templateNames_1.TemplateNames.MessageExtensionM365,
        };
    }
    static newApi() {
        return {
            id: "new-api",
            label: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.capability.copilotPluginNewApiOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.messageExtensionNewApiOption.detail"),
        };
    }
    static openApiSpec() {
        return {
            id: "api-spec",
            label: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.capability.copilotPluginApiSpecOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.messageExtensionApiSpecOption.detail"),
            data: templateNames_1.TemplateNames.MessageExtensionWithExistingApiSpec,
        };
    }
}
exports.MeArchitectureOptions = MeArchitectureOptions;
class OfficeAddinCapabilityOptions {
    static outlookAddinImport() {
        return {
            id: "outlook-addin-import",
            label: (0, localizeUtils_1.getLocalizedString)("core.importAddin.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("template.importAddin.detail"),
            data: templateNames_1.TemplateNames.OfficeAddinCommon,
        };
    }
    static officeContentAddin() {
        return {
            id: "office-content-addin",
            label: (0, localizeUtils_1.getLocalizedString)("core.officeContentAddin.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.officeContentAddin.detail"),
        };
    }
    static officeAddinImport() {
        return {
            id: "office-addin-import",
            label: (0, localizeUtils_1.getLocalizedString)("template.importOfficeAddin.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("template.importAddin.detail"),
            description: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.option.description.previewOnWindow"),
            data: templateNames_1.TemplateNames.OfficeAddinCommon,
        };
    }
    static outlookTaskPane() {
        return {
            id: "outlook-json-taskpane",
            label: (0, localizeUtils_1.getLocalizedString)("template.newTaskpaneAddin.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("template.newTaskpaneAddin.detail"),
            data: templateNames_1.TemplateNames.OutlookTaskpane,
        };
    }
    static wxpTaskPane() {
        return {
            id: "wxp-json-taskpane",
            label: (0, localizeUtils_1.getLocalizedString)("template.newTaskpaneAddin.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("template.newTaskpaneAddin.detail"),
            data: templateNames_1.TemplateNames.WXPTaskpane,
        };
    }
    static excelCFShortcut() {
        return {
            id: "wxp-json-cf-shortcut",
            label: (0, localizeUtils_1.getLocalizedString)("template.newCFShortcut.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("template.newCFShortcut.detail"),
            data: templateNames_1.TemplateNames.ExcelCFShortcut,
        };
    }
    static DAMetaOS() {
        return {
            id: "office-da-meta-os",
            label: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.DAMetaOS.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.DAMetaOS.detail"),
        };
    }
}
exports.OfficeAddinCapabilityOptions = OfficeAddinCapabilityOptions;
class BotCapabilityOptions {
    static basicBotId = "bot";
    static notificationBotId = "notification";
    static commandBotId = "command-bot";
    static workflowBotId = "workflow-bot";
    static basicBot() {
        return {
            id: BotCapabilityOptions.basicBotId,
            label: `${(0, localizeUtils_1.getLocalizedString)("core.BotNewUIOption.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.BotNewUIOption.detail"),
            data: templateNames_1.TemplateNames.DefaultBot,
        };
    }
    // need further sub-options to decide template name
    static notificationBot() {
        return {
            id: BotCapabilityOptions.notificationBotId,
            label: `${(0, localizeUtils_1.getLocalizedString)("core.NotificationOption.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.NotificationOption.detail"),
            buttons: [
                {
                    iconPath: "file-symlink-file",
                    tooltip: (0, localizeUtils_1.getLocalizedString)("core.option.github"),
                    command: "fx-extension.openTutorial",
                },
            ],
        };
    }
    static commandBot() {
        return {
            // id must match cli `yargsHelp`
            id: BotCapabilityOptions.commandBotId,
            label: `${(0, localizeUtils_1.getLocalizedString)("core.CommandAndResponseOption.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.CommandAndResponseOption.detail"),
            data: templateNames_1.TemplateNames.CommandAndResponse,
            buttons: [
                {
                    iconPath: "file-symlink-file",
                    tooltip: (0, localizeUtils_1.getLocalizedString)("core.option.github"),
                    command: "fx-extension.openTutorial",
                },
            ],
        };
    }
    static workflowBot() {
        const item = {
            id: BotCapabilityOptions.workflowBotId,
            label: `${(0, localizeUtils_1.getLocalizedString)("core.WorkflowOption.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.WorkflowOption.detail"),
            data: templateNames_1.TemplateNames.Workflow,
            buttons: [
                {
                    iconPath: "file-symlink-file",
                    tooltip: (0, localizeUtils_1.getLocalizedString)("core.option.github"),
                    command: "fx-extension.openTutorial",
                },
            ],
        };
        return item;
    }
}
exports.BotCapabilityOptions = BotCapabilityOptions;
class NotificationBotOptions {
    static appService() {
        return {
            id: "http-express",
            hostType: constants_1.HostType.AppService,
            label: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-express.label"),
            description: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-express.description"),
            detail: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-express.detail"),
            data: templateNames_1.TemplateNames.NotificationExpress,
        };
    }
    static appServiceForVS() {
        return {
            id: "http-webapi",
            hostType: constants_1.HostType.AppService,
            label: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-webapi.label"),
            description: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-webapi.description"),
            detail: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-webapi.detail"),
            data: templateNames_1.TemplateNames.NotificationWebApi,
        };
    }
    static functionsTimerTrigger() {
        return {
            id: "timer-functions",
            hostType: constants_1.HostType.Functions,
            triggers: [constants_1.NotificationTriggers.TIMER],
            label: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.timer-functions.label"),
            description: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.timer-functions.description"),
            detail: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.timer-functions.detail"),
            data: templateNames_1.TemplateNames.NotificationTimerTrigger,
        };
    }
    static functionsHttpAndTimerTrigger() {
        return {
            id: "http-and-timer-functions",
            hostType: constants_1.HostType.Functions,
            triggers: [constants_1.NotificationTriggers.HTTP, constants_1.NotificationTriggers.TIMER],
            label: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-and-timer-functions.label"),
            description: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-and-timer-functions.description"),
            detail: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-and-timer-functions.detail"),
            data: templateNames_1.TemplateNames.NotificationHttpTimerTrigger,
        };
    }
    static functionsHttpTrigger() {
        return {
            id: "http-functions",
            hostType: constants_1.HostType.Functions,
            triggers: [constants_1.NotificationTriggers.HTTP],
            label: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-functions.label"),
            description: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-functions.description"),
            detail: (0, localizeUtils_1.getLocalizedString)("plugins.bot.triggers.http-functions.detail"),
            data: templateNames_1.TemplateNames.NotificationHttpTrigger,
        };
    }
}
exports.NotificationBotOptions = NotificationBotOptions;
class DACapabilityOptions {
    static declarativeAgent() {
        return {
            id: "declarative-agent",
            label: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.projectType.declarativeAgent.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.projectType.declarativeAgent.detail"),
        };
    }
    static noPlugin() {
        return {
            id: "no",
            label: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.noPlugin.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.noPlugin.detail"),
            data: templateNames_1.TemplateNames.DeclarativeAgentBasic,
        };
    }
    static withPlugin() {
        return {
            id: "yes",
            label: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.addPlugin.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.addPlugin.detail"),
        };
    }
    static typeSpec() {
        return {
            id: "type-spec",
            label: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.apiPlugin.typeSpec.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.apiPlugin.typeSpec.detail"),
            data: templateNames_1.TemplateNames.DeclarativeAgentWithTypeSpec,
        };
    }
    static withGC() {
        return {
            id: "gc",
            label: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.addGC.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.addGC.detail"),
            data: templateNames_1.TemplateNames.DeclarativeAgentWithGraphConnector,
        };
    }
    static all() {
        const items = [
            DACapabilityOptions.noPlugin(),
            DACapabilityOptions.withPlugin(),
            DACapabilityOptions.withGC(),
            DACapabilityOptions.typeSpec(),
        ];
        return items;
    }
}
exports.DACapabilityOptions = DACapabilityOptions;
class ActionStartOptions {
    static newApi() {
        return {
            id: "new-api",
            label: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.capability.copilotPluginNewApiOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.capability.copilotPluginNewApiOption.detail"),
        };
    }
    static apiSpec() {
        return {
            id: "api-spec",
            label: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.capability.copilotPluginApiSpecOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.capability.copilotPluginApiSpecOption.detail"),
            data: templateNames_1.TemplateNames.DeclarativeAgentWithActionFromExistingApiSpec,
        };
    }
    static apiSpecWithSearch() {
        return {
            id: "api-spec",
            label: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.capability.copilotPluginApiSpecOption.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.capability.copilotPluginApiSpecOption.detail"),
            data: templateNames_1.TemplateNames.DeclarativeAgentWithActionFromExistingApiSpec,
        };
    }
    static DAMetaOS() {
        return {
            id: "da-meta-os",
            label: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.capability.DAMetaOS.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.capability.DAMetaOS.detail"),
            data: templateNames_1.TemplateNames.DeclarativeAgentMetaOSNewProject,
        };
    }
    static existingPlugin() {
        return {
            id: "existing-plugin",
            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.apiPlugin.importPlugin.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.apiPlugin.importPlugin.detail"),
            data: templateNames_1.TemplateNames.DeclarativeAgentWithExistingAction,
        };
    }
    static mcp() {
        return {
            id: "mcp",
            label: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.mcpForDa.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.mcpForDa.detail"),
            // description: getLocalizedString("core.createProjectQuestion.option.description.preview"),
            data: templateNames_1.TemplateNames.DeclarativeAgentWithActionFromMCP,
        };
    }
}
exports.ActionStartOptions = ActionStartOptions;
class DAMetaOSCapabilityOptions {
    static newDAMetaOSProject() {
        return {
            id: "da-meta-os-new-project",
            label: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.DAMetaOS.capability.newProject.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.DAMetaOS.capability.newProject.detail"),
            data: templateNames_1.TemplateNames.DeclarativeAgentMetaOSNewProject,
        };
    }
    static upgradeExistingProject() {
        return {
            id: "da-meta-os-upgrade-existing-project",
            label: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.DAMetaOS.capability.upgradeProject.label"),
            detail: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.DAMetaOS.capability.upgradeProject.detail"),
            data: templateNames_1.TemplateNames.DeclarativeAgentMetaOSUpgradeProject,
        };
    }
}
exports.DAMetaOSCapabilityOptions = DAMetaOSCapabilityOptions;
class ApiAuthOptions {
    static none(isME = false) {
        return {
            id: "none",
            label: "None",
            data: isME
                ? templateNames_1.TemplateNames.MessageExtensionWithNewApiFromScratch
                : templateNames_1.TemplateNames.DeclarativeAgentWithActionFromScratch,
        };
    }
    static apiKey() {
        return {
            id: "api-key",
            label: "API Key",
            // TODO: Update the name because the DeclarativeAgentWithActionFromScratchBearer template is currently actually ApiPluginFromScratchAPIKey.
            data: templateNames_1.TemplateNames.DeclarativeAgentWithActionFromScratchBearer,
        };
    }
    static bearerToken() {
        return {
            id: "bearer-token",
            label: "API Key (Bearer Token Auth)",
            data: templateNames_1.TemplateNames.MessageExtensionWithNewApiFromScratchUsingApiKey,
        };
    }
    static microsoftEntra(isME = false) {
        return {
            id: "microsoft-entra",
            label: "Microsoft Entra",
            data: isME
                ? templateNames_1.TemplateNames.MessageExtensionWithNewApiFromScratchUsingOAuth
                : templateNames_1.TemplateNames.DeclarativeAgentWithActionFromScratchOAuth,
        };
    }
    static oauth() {
        return {
            id: "oauth",
            label: "OAuth",
            data: templateNames_1.TemplateNames.DeclarativeAgentWithActionFromScratchOAuth,
        };
    }
}
exports.ApiAuthOptions = ApiAuthOptions;
function setTemplateName(selected, inputs) {
    if (selected.data) {
        inputs[questionNames_1.QuestionNames.TemplateName] = selected.data;
    }
}
function setTemplateNameAndGC(selected, inputs) {
    setTemplateName(selected, inputs);
    if (selected.id === DACapabilityOptions.withGC().id) {
        inputs[questionNames_1.QuestionNames.ProgrammingLanguage] = constants_1.ProgrammingLanguage.TS;
    }
}
//# sourceMappingURL=CapabilityOptions.js.map